import React, { Component } from 'react'
import { withRouter } from 'react-router'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import TaskDetailPageUI from './TaskDetailPageUI.js'
import {findTaskByTaskNumber}
        from '../../components/projectapp/taskList/helper/taskListHelper'
import {replaceTask}
        from '../../components/projectapp/taskList/helper/taskListCRUDHelper'

class TaskDetailPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      taskList: null,
      project: null,
      task: null,
      // not found
      notFound: false,
      taskNumber: null,
      // list of values
      projectUserMap: null,
      projectUserList: null,
    }
    this.projectId = null
  }

  render() {
    return (
      <TaskDetailPageUI
        context={this.props.context}
        task={this.state.task}
        project={this.state.project}
        notFound={this.state.notFound}
        messageList={this.state.messageList}
        // list of values
        projectUserMap={this.state.projectUserMap}
        projectUserList={this.state.projectUserList}
        //
        onTaskListUpdated={this.onTaskListUpdated}
        onForceTaskListRefresh={this.onForceTaskListRefresh}
        onForceProjectUserListRefresh={this.onForceProjectUserListRefresh}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getMessages(context)
    this.getTaskTreeFromCache(context)
    document.body.classList.add('g_h_100');
  }

  componentWillUnmount() {
    document.body.classList.remove('g_h_100');
  }

  getTaskTreeFromCache(context) {
    let taskTreeKeys = Object.keys(localStorage).filter(key => key.startsWith('TaskTree:'))
    let topTaskList, task
    for (let taskTreeKey of taskTreeKeys) {
      let taskListCache = localStorage.getItem(taskTreeKey)
      console.log(taskTreeKey, taskListCache) // keep this log, beccause getting error "Unexpected token u in JSON at position 0"
      topTaskList = JSON.parse(taskListCache).taskList
      task = findTaskByTaskNumber(topTaskList, this.props.match.params.taskNumber)
      if (task) {
        console.log('task in cache', task);
        break
      }
    }
    if (task) {
      this.setState({taskList: topTaskList, task: task})
      this.projectId = task.projectId
      this.getProjects(context)
      this.getProjectUsers(context)
    }
    else {
      this.getTaskNumberCallback(context)
    }
  }

  onForceTaskListRefresh = (projectId) => {
    CacheManager.removeObject(CacheKeys.TaskTree(this.state.project.projectId))
  }

  onForceProjectUserListRefresh = (projectId) => {
    CacheManager.removeObject(CacheKeys.ProjectUsers(projectId))
    this.setState({projectUserList: null}, this.getProjectUsers(this.props.context))
  }

  getTaskNumberCallback(context) {
    RestApiUtils.get(this.props.context,
      `/api/accounts/${context.session.accountId}/tasks/taskNumber/${this.props.match.params.taskNumber}`,
      this.onGetTaskNumberCallback, {}
    )
  }

  onGetTaskNumberCallback = (response) => {
    if (response.errorList.length > 0) {
      this.setState({taskNumber: this.props.match.params.taskNumber, notFound: true})
      return
    }
    let context = this.props.context
    this.projectId = response.projectId
    this.getTaskTree(context)
    this.getProjects(context)
    this.getProjectUsers(context)
  }

  getTaskTree(context) {
    console.log(this.class, '------------------------ getTaskTree');
    let cacheManager = new CacheManager({
      resource: `/api/projects/${this.projectId}/tasks`,
      cacheKey: CacheKeys.TaskTree(this.projectId),
      callback: this.getTaskTreeCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getTaskTreeCallback = (response) => {
    console.log(this.class, '------------------------ getTaskTreeCallback');
    if (response.errorList.length > 0) {
      this.props.history.replace('/projects')
      return
    }

    let task = findTaskByTaskNumber(response.taskList, this.props.match.params.taskNumber)
    if (!task) {
      // handle
    }

    this.setState({taskList: response.taskList, task: task})
  }

  // first need to translate project short code to project id
  getProjects(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/projects`,
      cacheKey: CacheKeys.Projects(context.session.accountId, context.session.userId),
      callback: this.getProjectsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getProjectsCallback = (response) => {
    if (response.errorList.length > 0) {
      this.props.history.replace('/projects')
      return
    }
    let projectsFiltered = response.projectList.filter(project => project.projectId === this.projectId)
    if (projectsFiltered.length === 1) {
      this.setState({project : projectsFiltered[0]})
    }
  }

  getProjectUsers(context) {
    let cacheManager = new CacheManager({
      resource: `/api/projects/${this.projectId}/users`,
      cacheKey: CacheKeys.ProjectUsers(this.projectId),
      callback: this.getProjectUsersCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(this.props.context)
  }

  getProjectUsersCallback = (response) => {
    let projectUserMap = response.projectUserList.reduce((map, user) => {map[user.userId] = user; return map}, {})
    this.setState({
      projectUserList: response.projectUserList,
      projectUserMap: projectUserMap
    })
  }

  onTaskListUpdated = updatedTaskList => {
    let currentTask
    updatedTaskList
      .forEach(updatedTask => {
        if (updatedTask.taskId === this.state.task.taskId)
          currentTask = updatedTask
        replaceTask(this.state.taskList, updatedTask.taskId, updatedTask)
      }
    )
    this.setState({taskList: this.state.taskList, task: currentTask})
  }

  getMessages(context) {
    let arr = [
      'c_task_not_found',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_task_dtl', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default withRouter(TaskDetailPageSF)
